import { render, staticRenderFns } from "./SecaoModal.vue?vue&type=template&id=38a3aa38&scoped=true"
import script from "./SecaoModal.vue?vue&type=script&lang=js"
export * from "./SecaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3aa38",
  null
  
)

export default component.exports